import {
  CHAPTERS_TAB,
  COMMENTS_TAB,
  DEEP_SEARCH_TAB,
  PLAYLIST_TAB,
  SLIDES_TAB,
  TRANSCRIPTS_TAB,
} from '@/modules/common/constants/tabs';

export const REQUEST_SIZE_SEARCH_ITEMS = 10;

export const MINIMUM_LANGUAGE_COUNT = 2;

const LANGUAGE_ANY = {
  label: 'Any Language',
  value: '',
};

export const FILTER_CONFIG_LANGUAGE_DEFAULT = LANGUAGE_ANY;

const TIME_ANY = {
  label: 'Any Time',
  value: '',
};

const TIME_24_HOURS = {
  label: 'Past 24 hours',
  value: 'day',
};

const TIME_WEEK = {
  label: 'Past Week',
  value: 'week',
};

const TIME_MONTH = {
  label: 'Past Month',
  value: 'month',
};

export const FILTER_CONFIG_TIME = [TIME_ANY, TIME_24_HOURS, TIME_WEEK, TIME_MONTH];

export const FILTER_CONFIG_TIME_DEFAULT = TIME_ANY;

const DURATION_ANY = {
  label: 'Any Duration',
  value: '',
};

const DURATION_UNDER_4 = {
  label: 'Under 4 minutes',
  value: 'under4',
  to: 4 * 60 * 1000 - 1,
};

const DURATION_4_TO_20 = {
  label: '4 - 20 minutes',
  value: '4to20',
  from: 4 * 60 * 1000,
  to: 20 * 60 * 1000,
};

const DURATION_OVER_20 = {
  label: 'Over 20 minutes',
  value: 'over20',
  from: 20 * 60 * 1000 + 1,
};

export const FILTER_CONFIG_DURATION = [DURATION_ANY, DURATION_UNDER_4, DURATION_4_TO_20, DURATION_OVER_20];

export const FILTER_CONFIG_DURATION_DEFAULT = DURATION_ANY;

export const QUERY_SEARCH_KEY = 'q';
export const QUERY_LANGUAGE_KEY = 'l';
export const QUERY_TIME_KEY = 't';
export const QUERY_DURATION_KEY = 'd';
export const QUERY_VIDEO_START_PLAY_KEY = 'pt';
export const QUERY_FOCUSED_COMMENT_KEY = 'fc';
export const QUERY_SELECTED_CHIP_KEY = 'c';
export const QUERY_SELECTED_CHIP_TAG_KEY = 'ct';
export const QUERY_SELECTED_CHIP_IAB_KEY = 'ci';

export const QUERY_SELECTED_TAB_KEY = 'tab';
export const QUERY_PLAYLIST_TAB_VALUE = 'pl';
export const QUERY_DEEP_SEARCH_TAB_VALUE = 'ds';
export const QUERY_CHAPTERS_TAB_VALUE = 'ch';
export const QUERY_TRANSCRIPTS_TAB_VALUE = 'tr';
export const QUERY_COMMENTS_TAB_VALUE = 'co';
export const QUERY_SLIDES_TAB_VALUE = 'sl';
export const QUERY_TO_TAB_MAPPING = {
  [QUERY_PLAYLIST_TAB_VALUE]: PLAYLIST_TAB,
  [QUERY_DEEP_SEARCH_TAB_VALUE]: DEEP_SEARCH_TAB,
  [QUERY_CHAPTERS_TAB_VALUE]: CHAPTERS_TAB,
  [QUERY_TRANSCRIPTS_TAB_VALUE]: TRANSCRIPTS_TAB,
  [QUERY_COMMENTS_TAB_VALUE]: COMMENTS_TAB,
  [QUERY_SLIDES_TAB_VALUE]: SLIDES_TAB,
};
export const TAB_TO_QUERY_MAPPING = {
  [PLAYLIST_TAB]: QUERY_PLAYLIST_TAB_VALUE,
  [DEEP_SEARCH_TAB]: QUERY_DEEP_SEARCH_TAB_VALUE,
  [CHAPTERS_TAB]: QUERY_CHAPTERS_TAB_VALUE,
  [TRANSCRIPTS_TAB]: QUERY_TRANSCRIPTS_TAB_VALUE,
  [COMMENTS_TAB]: QUERY_COMMENTS_TAB_VALUE,
  [SLIDES_TAB]: QUERY_SLIDES_TAB_VALUE,
};

export const ALL_POSSIBLE_QUERY_COLLECTION = {
  [QUERY_SEARCH_KEY]: '',
  [QUERY_LANGUAGE_KEY]: FILTER_CONFIG_LANGUAGE_DEFAULT.value,
  [QUERY_TIME_KEY]: FILTER_CONFIG_TIME_DEFAULT.value,
  [QUERY_DURATION_KEY]: FILTER_CONFIG_DURATION_DEFAULT.value,
  [QUERY_VIDEO_START_PLAY_KEY]: '',
  [QUERY_SELECTED_TAB_KEY]: '',
};

export const SEARCH_QUERY_COLLECTION = {
  [QUERY_SEARCH_KEY]: '',
  [QUERY_LANGUAGE_KEY]: FILTER_CONFIG_LANGUAGE_DEFAULT.value,
  [QUERY_TIME_KEY]: FILTER_CONFIG_TIME_DEFAULT.value,
  [QUERY_DURATION_KEY]: FILTER_CONFIG_DURATION_DEFAULT.value,
};

export const ALL_POSSIBLE_QUERY_KEYS = Object.keys(ALL_POSSIBLE_QUERY_COLLECTION);
export const SEARCH_QUERY_KEYS = Object.keys(SEARCH_QUERY_COLLECTION);
